import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaPerfisLayer from "../components/ListaPerfisLayer";
import { useTranslation } from "../i18n/I18nContext";

const ListaPerfisPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("perfis.breadcrumb.list")} />
      <ListaPerfisLayer />
    </MasterLayout>
  );
};

export default ListaPerfisPage;
